import * as angular from 'angular';

import { SelectOption } from '@mode/shared/ui-angularjs';

class InlineSelectFieldController {
  private selected: SelectOption;
  private onChange: ($args: { $option: SelectOption }) => void;

  static $inject = ['$scope'];

  constructor(private $scope) {}

  private handleSelection($option: SelectOption): void {
    this.$scope.$applyAsync(() => {
      this.selected = $option;
    });

    this.onChange({ $option });
  }
}

export const InlineSelectFieldComponent: angular.IComponentOptions = {
  controller: InlineSelectFieldController,
  controllerAs: 'ctrl',
  bindings: {
    inputId: '@',
    inputName: '@',
    onChange: '&',
    options: '<',
    selected: '<',
    title: '@',
  },
  template: `
    <div class="inline-select-field">
      <select-field
        input-id="{{ ctrl.inputId }}"
        input-name="{{ ctrl.inputName }}"
        selected="ctrl.selected"
        options="ctrl.options"
        on-change="ctrl.handleSelection($option)"
        title="{{ ctrl.title }}"
      >
        <select-field-control>
          <span class="inline-select-field-control form-control icon-caret">{{ ctrl.selected.label }}</span>
        </select-field-control>
      </select-field>
    </div>
  `,
};
